module.exports = window.Savane;